import React, { useState, useContext, useEffect, useRef } from 'react';
import MenuItem from './components/MenuItem';
import { demoSteps } from './constants';
import DemoGrid from './components/DemoGrid';
import MobileHeader from './components/MobileHeader';
import { MobileViewContext } from '../../context/MobileViewContext';
import BusinessData from './data/Business';
import PlusData from './data/Plus';
import SharedData from './data/Shared';
import GroupData from './data/Group';
import Modal from './components/Modal';
import {
  Main,
  SectionHeading,
  TitleSpan,
  TitleHeading,
  StyledDemo,
  SectionGrid,
  Menu,
  TextInstruction,
  WrapMenuItems,
  DemoContent,
  DemoContentImage,
  SectionCta,
  ButtonPrimary,
  ButtonSecondary,
  IllustrationImage,
  DemoVideo,
  NavigateContainer,
  NavigateTop,
  NavigateBottom,
  WrapDemoVideo,
  ShellVideoOptions,
  TextVideoOptionsLabel,
  WrapMobileSingleDemoInstruction
} from './styled';
// import Arrow from "../../assets/icons/Arrow.svg";

import { AngleArrow } from '../../assets/icons/angle-up-solid';

const MENU_ITEM_HEIGHT = 110;
const MAX_DEMO_LENGTH = 6;

const importedData =
  (process.env.REACT_APP_TARGET && process.env.REACT_APP_TARGET.includes('plus')) ||
  window.location.href.includes('plus')
    ? JSON.parse(JSON.stringify(PlusData))
    : JSON.parse(JSON.stringify(BusinessData));

// Add shared demos
importedData.demos =
  (process.env.REACT_APP_TARGET && process.env.REACT_APP_TARGET.includes('plus')) ||
  window.location.href.includes('plus')
    ? importedData.demos.concat(BusinessData.demos).concat(SharedData.demos)
    : importedData.demos.concat(SharedData.demos);

// Add custom group fallback data
importedData.intro = !(
  process.env.REACT_APP_TARGET.includes('plus') || process.env.REACT_APP_TARGET.includes('business')
)
  ? JSON.parse(JSON.stringify(GroupData.intro))
  : importedData.intro;

export const Demo = () => {
  const [selectedDemo, setSelectedDemo] = useState(null);
  const [demoStep, setDemoStep] = useState(0);
  const [data, setData] = useState(importedData);
  const [singleDemo, setSingleDemos] = useState(false);
  const isMobile = useContext(MobileViewContext);
  const demoList = useRef(null);
  const isCustomGroup =
    process.env.REACT_APP_TARGET &&
    !process.env.REACT_APP_TARGET.includes('plus') &&
    !process.env.REACT_APP_TARGET.includes('business');

  // Filter demos
  const setGroupedData = () => {
    let demoIds = null;
    if (process.env.REACT_APP_TARGET) {
      demoIds = process.env.REACT_APP_TARGET.replace(/^\D+/g, '-'); // Replace all leading non-digits
    }
    let hasNumber = false;
    if (demoIds) {
      hasNumber = /\d/.test(demoIds);
    }
    if (!hasNumber) {
      if (data.demos.length === 1) {
        setSingleDemos(true);
      }
      return;
    }
    // Extract ids from env variable
    const ids = demoIds
      .split('-')
      .map((x) => +x)
      .filter(Boolean);

    // Merge data files
    const mergedData = JSON.parse(JSON.stringify(BusinessData));
    mergedData.demos = mergedData.demos.concat(PlusData.demos);
    mergedData.demos = mergedData.demos.concat(SharedData.demos);

    const filteredDemos = mergedData.demos.filter((demo) => ids.includes(demo.id));
    if (filteredDemos) {
      const filteredData = JSON.parse(JSON.stringify(data));
      filteredData.demos = filteredDemos;
      if (filteredData.demos.length === 1) {
        setSingleDemos(true);
      }
      setData(filteredData);
    }
  };

  const onDemoSelection = (id) => {
    if (!id) {
      return;
    }
    const foundDemo = data.demos.find((demo) => demo.id === id);
    setSelectedDemo(foundDemo);

    if (selectedDemo && selectedDemo.id !== id) {
      // If a different demo is selected, jump to new demo start
      setDemoStep(0);
    }
  };

  const onDemoStart = () => {
    setDemoStep(demoSteps.intro);
  };

  const advanceDemoStep = () => {
    setDemoStep(demoStep + 1);
  };

  const onNextDemo = () => {
    const index = data.demos.findIndex((demo) => demo.id === selectedDemo.id);
    const nextDemoIndex = index + 1;
    const nextDemoExist = !!data.demos[nextDemoIndex];

    if (index >= 0 && nextDemoExist) {
      setSelectedDemo(data.demos[nextDemoIndex]);
      setDemoStep(demoSteps.intro);
    } else {
      // On last demo, go back to the first demo
      setSelectedDemo(data.demos[0]);
      setDemoStep(0);
    }
  };

  const onContact = (e, demoIdentifier) => {
    //Add Code for Contact Sales Functionality
    e.preventDefault();
    demoIdentifier &&
      window.parent.postMessage(
        {
          func: 'handleContactForm',
          demo: demoIdentifier
        },
        '*'
      );
  };

  const onCloseDemo = () => {
    setSelectedDemo(null);
  };

  const onModalClose = () => {
    advanceDemoStep();
  };

  const scrollDemoList = (range) => {
    demoList.current.scrollBy({ top: range, left: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    setGroupedData();
  }, []);

  const getMenuVisibility = () => {
    if (!isMobile && singleDemo) {
      return false;
    }

    if (isMobile && selectedDemo) {
      return false;
    }

    return true;
  };

  return (
    <StyledDemo selectedDemo={selectedDemo}>
      {selectedDemo ? (
        <MobileHeader
          title={selectedDemo.title}
          icon={selectedDemo.icon}
          actionText={selectedDemo.actionText}
          onClose={onCloseDemo}
        />
      ) : (
        <></>
      )}
      <Main>
        <SectionHeading isVisible={!selectedDemo}>
          <TitleSpan>{data.intro.title}</TitleSpan>
          <TitleHeading>{isCustomGroup ? data.intro.heading : data.intro.businessHeading}</TitleHeading>
        </SectionHeading>
        <SectionGrid singleDemo={singleDemo}>
          <Menu isVisible={getMenuVisibility()}>
            <TextInstruction hideOnMobile={singleDemo}>{data.intro.instruction}</TextInstruction>
            {!isMobile && data.demos && data.demos.length > MAX_DEMO_LENGTH && (
              <NavigateContainer>
                <NavigateTop
                  // src={AngleArrow}
                  onClick={() => {
                    scrollDemoList(-MENU_ITEM_HEIGHT);
                  }}
                >
                  <AngleArrow />
                </NavigateTop>
              </NavigateContainer>
            )}

            {isMobile && singleDemo && (
              <>
                <WrapMobileSingleDemoInstruction>
                  <TextVideoOptionsLabel>{`${data.demos[0].title} ${data.demos[0].actionText}`}</TextVideoOptionsLabel>
                  <ButtonPrimary
                    onClick={() => {
                      setSelectedDemo(data.demos[0]);
                    }}
                  >
                    Begin
                  </ButtonPrimary>
                </WrapMobileSingleDemoInstruction>
              </>
            )}

            <WrapMenuItems ref={demoList} hideOnMobile={singleDemo}>
              {data.demos &&
                data.demos.map((demo, index) => (
                  <MenuItem
                    key={index}
                    title={demo.title}
                    actionText={demo.actionText}
                    icon={demo.icon}
                    onClick={onDemoSelection}
                    id={demo.id}
                    selectedDemo={selectedDemo}
                  />
                ))}
            </WrapMenuItems>
            {!isMobile && data.demos && data.demos.length > MAX_DEMO_LENGTH && (
              <NavigateContainer>
                <NavigateBottom
                  onClick={() => {
                    scrollDemoList(MENU_ITEM_HEIGHT);
                  }}
                >
                  <AngleArrow />
                </NavigateBottom>
              </NavigateContainer>
            )}
          </Menu>

          {!selectedDemo && (
            <WrapDemoVideo smallDemo={singleDemo && !isMobile}>
              <DemoVideo loop autoPlay muted src={data.animation}></DemoVideo>
              {singleDemo && !isMobile && (
                <ShellVideoOptions>
                  <TextVideoOptionsLabel>{`${data.demos[0].title} ${data.demos[0].actionText}`}</TextVideoOptionsLabel>
                  <ButtonPrimary
                    onClick={() => {
                      setSelectedDemo(data.demos[0]);
                    }}
                  >
                    Begin
                  </ButtonPrimary>
                </ShellVideoOptions>
              )}
            </WrapDemoVideo>
          )}
          {selectedDemo && (
            <>
              {demoStep === demoSteps.intro && (
                <DemoGrid
                  selectedDemo={selectedDemo}
                  data={data}
                  onNextDemo={onNextDemo}
                  onContact={onContact}
                  onDemoStart={onDemoStart}
                  demoStep={demoStep}
                  demoSteps={demoSteps}
                  advanceDemoStep={advanceDemoStep}
                  isMobile={isMobile}
                  singleDemo={singleDemo}
                />
              )}
              {demoStep === demoSteps.demo && (
                <>
                  {!isMobile && (
                    <Modal isOpen onClose={onModalClose}>
                      <DemoContent>
                        {selectedDemo.walnut ? (
                          <DemoContentImage src={selectedDemo.walnut} />
                        ) : (
                          <IllustrationImage src={'https://via.placeholder.com/1920x1080?text=Demo'} />
                        )}
                      </DemoContent>
                    </Modal>
                  )}

                  {isMobile && (
                    <>
                      <IllustrationImage src={selectedDemo.walnutPlaceholder} />
                      <span>
                        This interactive experience is optimized for larger screens and is not available on mobile
                        devices at this time.
                      </span>
                      <SectionCta>
                        <ButtonPrimary onClick={advanceDemoStep}>Next Step</ButtonPrimary>

                        <ButtonSecondary addMargin onClick={onDemoStart}>
                          Start over
                        </ButtonSecondary>
                      </SectionCta>
                    </>
                  )}
                </>
              )}
              {demoStep === demoSteps.outro && (
                <DemoGrid
                  selectedDemo={selectedDemo}
                  data={data}
                  onNextDemo={onNextDemo}
                  onContact={onContact}
                  onDemoStart={onDemoStart}
                  demoStep={demoStep}
                  demoSteps={demoSteps}
                  advanceDemoStep={advanceDemoStep}
                  isMobile={isMobile}
                  singleDemo={singleDemo}
                />
              )}
            </>
          )}
        </SectionGrid>
      </Main>
    </StyledDemo>
  );
};

export default Demo;
